import { render, staticRenderFns } from "./buyShebeiInfo.vue?vue&type=template&id=3997f7a4&scoped=true&"
import script from "./buyShebeiInfo.vue?vue&type=script&lang=js&"
export * from "./buyShebeiInfo.vue?vue&type=script&lang=js&"
import style0 from "./buyShebeiInfo.vue?vue&type=style&index=0&id=3997f7a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3997f7a4",
  null
  
)

export default component.exports